<template>
  <ul class="tree-view">
    <TreeViewItem v-for="item in tree" :key="item.id" :nodeData="item" :helpData="helpData" @operate="operate" @toggleCollapse="toggleCollapse" />
  </ul>
</template>

<script>
import TreeViewItem from '@/components/utils/tree-view-item'

export default {
  name: 'TreeView',
  data () {
    return {
      helpData: {
        collapseMap: {},
        activeItem: {}
      }
    }
  },
  components: { TreeViewItem },
  props: {
    tree: {
      type: Array,
      required: true
    }
  },
  methods: {
    operate (operation, value) {
      this.helpData.activeItem = value
      if (value.operations && value.operations.includes(operation)) {
        this.$emit(
          'operate',
          operation,
          Object.assign(Object.create(null), value)
        )
      }
    },
    toggleCollapse (node) {
      const { collapseMap } = this.helpData
      this.$set(collapseMap, node.id, !collapseMap[node.id])
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/tree-view.vue